import React, { useState } from 'react';

import IssueComponent from '../IssueComponent';
import LoadingSpinnerComponent from '../LoadingSpinnerComponent';
import { useAuth } from '../../context/authContext';

const networking = require('../../Networking/API');

function TopKeywordsComponent({ app, limit, showDetails, reviews }: any) {
    const { token } = useAuth();

    const [loading, setLoading] = useState(true);

    var [issues, setIssues] = useState(null) as any[];
    var [topReviews, setTopReviews] = useState(null) as any[];

    var currentReviews = reviews

    if (!topReviews && currentReviews === undefined) {
        getData();
    }

    if (!issues) {
        getMainIssues();
    }

    function updatePage() {
        getMainIssues()
    }

    function getData() {
        networking.reviewsFor(app.id, token).then((reviews: any) => {
            setTopReviews(reviews);
            setLoading(false);
        }).catch((error: Error) => {
            setLoading(false);
        });
    }

    function getMainIssues() {
        networking.issuesFor(app.id, token).then((issues: any) => {
            setIssues(issues);
            setLoading(false);
        }).catch((error: Error) => {
            setLoading(false);
        });
    }

    return (
        <div>
            {loading ?
                <LoadingSpinnerComponent />
                :
                <div>
                    {(currentReviews || topReviews) &&
                        < IssueComponent
                            app={app}
                            reviews={currentReviews ?? topReviews}
                            issues={issues}
                            limit={limit}
                            showHeader={true}
                            handler={updatePage} />
                    }
                </div>
            }
        </div>
    )

}

export default TopKeywordsComponent;